import { ReactElement } from 'react';

import Alert from '@mui/material/Alert';

import ApplicationRequest from '../../types/ApplicationRequest';
import GratiDirectory from '../common/GratiDirectory';
import Hourglass from '../common/Hourglass';

import ApplicationRequestListItem from './ApplicationRequestListItem';

interface ApplicationRequestDirectoryProps {
  applicationRequests?: ApplicationRequest[];
  isLoading?: boolean;
  error?: Error | null;
  pageTitle?: string;
  onCountChange?: (count: number) => void;
}

export default function ApplicationRequestDirectory({
  applicationRequests,
  isLoading,
  error,
  pageTitle: _pageTitle,
  onCountChange,
}: ApplicationRequestDirectoryProps): ReactElement {
  if (isLoading) {
    return <Hourglass />;
  }

  if (error) {
    console.log('applicationRequestsError:', error.message, error.name, error.stack);
    return <Alert severity="error">Error loading application requests: {error.message}</Alert>;
  }

  if (!applicationRequests || applicationRequests.length === 0) {
    return <Alert severity="info">No application requests found.</Alert>;
  }

  // Notify parent of count changes
  if (onCountChange) {
    onCountChange(applicationRequests.length);
  }

  return (
    <GratiDirectory>
      {applicationRequests.map((request) => (
        <ApplicationRequestListItem key={request.itemId} applicationRequest={request} isDividerDisplayed={true} />
      ))}
    </GratiDirectory>
  );
}
